import { render, staticRenderFns } from "./RoyaDetail.vue?vue&type=template&id=218f1be8&scoped=true&"
import script from "./RoyaDetail.vue?vue&type=script&lang=js&"
export * from "./RoyaDetail.vue?vue&type=script&lang=js&"
import style0 from "./RoyaDetail.vue?vue&type=style&index=0&id=218f1be8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218f1be8",
  null
  
)

export default component.exports